<template>
	<el-dialog :visible.sync="showRecommend" :title="title">
		<el-form label-width="100px">
			<x-form
				label="推荐列表"
				type="checkbox"
				:options="listOpts"
				v-model="recommendData"
			></x-form>
			<x-form
				label="置顶"
				type="radio"
				:options="topOpts"
				v-model="is_top"
			></x-form>
			<x-form
				label="精选"
				type="radio"
				:options="topOpts"
				v-model="is_careful_chosen"
			></x-form>
			
		</el-form>
		<div slot="footer">
			<el-button @click="showRecommend = false">取消</el-button>
			<el-button type="primary" @click="confirm">确认</el-button>
		</div>
	</el-dialog>
</template>

<script type="text/javascript">
import {
	saveGroup
} from '@/api/group'
export default {
	data() {
		return {
			showRecommend: false,
			listOpts: [
				{
					label: '最热',
					value: 1
				},
				{
					label: '最新',
					value: 2
				},
				{
					label: '不推荐',
					value: 3
				},
				{
					label: '全部小组',
					value: 4
				}
			],
			topOpts: [
				{
					label: '是',
					value: 2
				},
				{
					label: '否',
					value: 1
				}
			],
			title: '',
			recommendData: [],
			is_top: 1,
			is_careful_chosen: 1
		};
	},
	props: {
		fetchList: Function
	},
	watch: {
		recommendData(value) {
			

			const index = value.indexOf(3);

			if (index !== -1 && index !== 0 && value.length > 1) {
				this.recommendData = [3];
			} else {
				console.log(value);
				if (index !== -1 && value.length > 1) {
					this.recommendData.splice(index, 1)
				}
			}
		}
	},
	methods: {
		show(row) {
			const { is_top, is_newest, is_hottest,is_all, is_careful_chosen, id } = row;
			console.log(row)
			this.is_careful_chosen = is_careful_chosen;
			this.is_top = is_top;
			this.id = id

			if (is_newest == 2) {
				this.recommendData.push(2);
			}
			if (is_hottest == 2) {
				this.recommendData.push(1);
			}

			if (is_all == 2) {
				this.recommendData.push(4);
			}

			if (is_newest == 1 && is_hottest == 1 && is_all == 1) {
				this.recommendData.push(3);
			}

			this.title = row.group_name;
			this.showRecommend = true;
		},
		confirm() {
			let is_hottest,is_newest,is_all
			if (this.recommendData[0] == 3) {
				is_hottest = 1
				is_newest = 1
				is_all = 1
			} else {
				if (this.recommendData.indexOf(1) !== -1) {
					is_hottest = 2
				} else {
					is_hottest = 1
				}
				if (this.recommendData.indexOf(2) !== -1) {
					is_newest = 2
				} else {
					is_newest = 1
				}

				if (this.recommendData.indexOf(4) !== -1) {
					is_all = 2
				} else {
					is_all = 1
				}
			}

			saveGroup({
				id: this.id,
				is_top: this.is_top,
				is_careful_chosen: this.is_careful_chosen,
				is_newest,
				is_hottest,
				is_all
			}).then(res => {
				this.$message.success('保存成功！')
				this.showRecommend = false
				this.fetchList && this.fetchList()
			})
		}
	},
	mounted() {}
};
</script>

<style lang="less"></style>
